module.exports = __webpack_public_path__ + "static/media/1-9.40164fa9.mp3";